<div dropdown class="btn-group org-master-select" [autoClose]="true" (isOpenChange)="onDropdownOpen($event)">
  <button dropdownToggle type="button" class="btn btn-default dropdown-toggle">
    <span class="summary-text" [class.placeholder]="!selectedLabel">{{ selectedLabel || placeholder }}</span>
    <span class="caret"></span>
  </button>

  <div *dropdownMenu class="dropdown-menu" role="menu" (click)="$event.stopPropagation()">
    <div *ngIf="mastersLoading" class="empty-message">読み込み中...</div>

    <ng-container *ngIf="!mastersLoading">
      <div class="header-menu">
        <div class="menu">
          <bl-checkbox
            [label]="'全て選択'"
            [checked]="isAllSelected(getItemsForVisibleParentRows())"
            [disabled]="parentRows.length === 0"
            [exceptViewMode]="true"
            (changeEvent)="setSelected(getItemsForVisibleParentRows(), $event.target.checked)"
          ></bl-checkbox>
          <bl-text-input
            [value]="parentFilterText"
            [exceptViewMode]="true"
            (inputEvent)="parentFilterText = $event.target.value; rebuildParentList()"
          ></bl-text-input>
        </div>
        <div class="menu">
          <bl-checkbox
            [label]="'全て選択'"
            [checked]="isAllSelected(childList)"
            [disabled]="childList.length === 0"
            [exceptViewMode]="true"
            (changeEvent)="setSelected(childList, $event.target.checked)"
          ></bl-checkbox>
          <bl-text-input
            [value]="childFilterText"
            [exceptViewMode]="true"
            (inputEvent)="childFilterText = $event.target.value; rebuildChildList()"
          ></bl-text-input>
        </div>
      </div>

      <div class="list-disp-area">
        <ul class="list-area">
          <li *ngIf="parentRows.length === 0" class="empty-message">該当する候補が見つかりません。</li>
          <li
            *ngFor="let row of parentRows"
            class="parent-row"
            [class.active]="row.rowId === activeRowId"
            (click)="showChildList(row.rowId)"
          >
            <bl-checkbox
              class="parent-checkbox"
              [checked]="isAllSelected(getItemsForParentRow(row.rowId))"
              [exceptViewMode]="true"
              (changeEvent)="onParentCheckboxChange(row.rowId, $event.target.checked)"
            ></bl-checkbox>
            <span class="parent-name">{{ row.label }}</span>
          </li>
        </ul>
        <ul class="list-area">
          <li *ngIf="!activeRowId" class="empty-message">左の名称を選択してください。</li>
          <li *ngIf="activeRowId && childList.length === 0" class="empty-message">該当する候補が見つかりません。</li>
          <li *ngFor="let item of childList">
            <bl-checkbox
              [label]="item.label"
              [checked]="isAllSelected([item])"
              [exceptViewMode]="true"
              (changeEvent)="setSelected([item], $event.target.checked)"
            ></bl-checkbox>
          </li>
        </ul>
      </div>
    </ng-container>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/page/contact-list-page/org-master-select-search/org-master-select-search.component.html